<template>
  <div id="user-info">
    <div class="home-head">
      <head-common :nav-list="navList1" :indexProp="indexProp1"></head-common>
    </div>
    <div class="left-menu">
      <ul>
        <li class="study-content-others-item" v-for="item in pageMenu.leftItem" @click="displayLeftDetails(item.id)">
          <h2>{{item.name}}</h2>
        </li>
      </ul>
    </div>
    <div class="right-content">
      <div class="content-details">
        <h2 v-if="pageMenu.goToLeftItem === ''">陪伴是最长情的告白，相守是最温柔的承诺</h2>
        <base-info class="base-info" v-else-if="pageMenu.goToLeftItem === pageMenu.leftItem[0].id && user.id != null"></base-info>
        <div id="base-my-article" v-else-if="pageMenu.goToLeftItem === pageMenu.leftItem[1].id">
          <my-articles ref="child"
                       @searchResult = "searchResult0" :page="articleQuery.number" :size="articleQuery.size" :queryVo="articleQuery"
          ></my-articles>
        </div>
        <h2 v-else-if="pageMenu.goToLeftItem === pageMenu.leftItem[2].id">{{pageMenu.leftItem[2].name}}</h2>
        <h2 v-else-if="pageMenu.goToLeftItem === pageMenu.leftItem[3].id">{{pageMenu.leftItem[3].name}}</h2>
      </div>
    </div>
    <div class="home-footer">
      <footer-common></footer-common>
    </div>
  </div>
</template>

<script>
  import {getLocalStorage} from "./../../utils/CommonUtil";
  import {loginUserKey} from "./../../utils/Config";
  import HeadCommon from './../HeadCommon.vue'
  import SimpleClickEvent from './../common/SimpleClickEvent.vue'
  import ArticleList from './../articles/ArticleList.vue'
  import FooterCommon from "../FooterCommon";
  import MyBaseInfo from "./MyBaseInfo";
  import BaseInfo from "./BaseInfo";
  import MyArticles from "./MyArticles";

  export default {
    name: "UserInfo",
    data: function () {
      return {
        indexProp1: 1,
        navList1: [
          {routeName: "userLogin", navName: "登录", onClickOne: false},
          {routeName: "UserInfo", navName: "其他", onClickOne: false},
          {routeName: "Study", navName: "学习", onClickOne: false},
          {routeName: "home", navName: "首页", onClickOne: false}
        ],
        pageMenu: {
          leftItem: [
            {id: "userBaseInfo", name: "基本信息"},
            {id: "myArticles", name: "我的文章"},
            {id: "myFans", name: "我的粉丝"},
            {id: "myCollection", name: "我的收藏"},
          ],
          goToLeftItem: ""
        },
        user: {
          id: null,
          username: ""
        },
        articleQuery: {
          keyword: "",
          startTime: null,
          endTime:null,
          number: 0,
          size: 5
        },
        getPageLast: false
      }
    },
    methods: {
      clickMore: function () {
        /*todo 判断是否拿到页数*/
        this.getPage = false;
        //this.pageSize = 0;
      },
      clickMoreLeave: function () {
        this.getPage = true;
        console.log(2)
      },
      displayLeftDetails: function (leftItemValue) {
        this.pageMenu.goToLeftItem = leftItemValue;
        if (leftItemValue === 'userBaseInfo'){

        }
        debugger;
        if (leftItemValue === 'myArticles'){
          //this.articleQuery.number = 0;
          //this.searchAction0 = true;
          //let aa = document.getElementById('base-my-article');
          //this.$refs.child.searchQuery(this.articleQuery.number, this.size);
          console.log(this.articleQuery, 'myArticles');
        }
        console.log(this.pageMenu.goToLeftItem, 'leftItemValue');
      },
      initUser: function () {
        let user1 = getLocalStorage(loginUserKey);
        let json = JSON.parse(user1);
        console.log(user1, "initUser-user");
        if (json != null){
          this.user.id = json.id;
          this.user.username = json.username;
        }
      },
      searchResult0: function(x, y) {
        debugger
        this.getPageLast = x;
        this.articleQuery.number = y;
        console.log("searchResult0-:",this.getPageLast,this.articleQuery.number);
        //this.searchAction0 = data;
      }
    },
    created(){
      this.initUser();
    },
    components: {
      MyArticles,
      BaseInfo,
      MyBaseInfo,
      FooterCommon,
      HeadCommon,
      SimpleClickEvent,
      ArticleList
    }
  }
</script>

<style scoped>
  div, img, ul, li, p, label, input {
    margin: 0 auto;
    padding: 0;
    border: 0;
  }
  #user-info {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(178, 255, 166, 0.44);
  }
  #user-info .left-menu {
    position: relative;
    display: inline-block;
    width: 20%;
    height: 600px;
    float: left;
    border-style: solid;
    border-color: #797979;
    border-width: 0 2px 0 0;
  }
  #user-info .left-menu .study-content-others-item {
    display: inline-block;
    width: 100%;
    height: 10%;
    margin: 5px 0;
    border-style: dotted;
    border-color: #797979;
    border-width: 0 0 2px 0;
    font-size: 1.2em;
    line-height: 1.8em;
    animation: border-color-move 4s infinite linear alternate;
  }
  #user-info .right-content {
    position: relative;
    display: inline-block;
    width: 75%;
    height: 100%;
    float: right;
    margin-top: 0px;
    padding: 24px;
    text-align: center;
  }
  #user-info .right-content .content-details {
    display: block;
    margin: 0px;
    padding: 5px;
    border-style: solid;
    border-color: #189dce;
    border-width: 0 0 2px 0;
    line-height: 2.5em;
    font-size: 1.25em;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    animation: border-color-move 4s infinite linear alternate;
  }
  #user-info .right-content .content-details .base-info {
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #user-info .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
  /*规定动画*/
  @keyframes border-color-move {
    0% { border-color: #2fffbb;}
    25% { border-color: #ffdc51;}
    50% { border-color: #ff68e3;}
    75% { border-color: #2dccff;}
    100% { border-color: #34ff78;}
  }

</style>



// WEBPACK FOOTER //
// src/components/user/UserInfo.vue